export enum CurrencyType {
  PLN = 'PLN',
  USD = 'USD',
  EUR = 'EUR',
}
